export const PREVIEW_FETCH_DEBOUNCE_MS = 150;
export const PREVIEW_SHOW_DELAY_MS = 150;
export const PREVIEW_HIDE_DELAY_MS = 300;

export const PREVIEW_FLOATING_OFFSET_PX = 10;
export const PREVIEW_FLOATING_VIEWPORT_PADDING_PX = 8;
